export default {
    namespaced: true,
    state: {
        theme: {
            mode: 'auto',
            isDark: true
        }
    },
    actions: {
        goToTheme({ commit }, themeModeVal) {
            commit('setMode', themeModeVal);
            localStorage.setItem('theme-mode', themeModeVal)
            if (themeModeVal === 'auto') { // If auto, check Mac theme settings
                commit('setIsDark', window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches)
            } else if (themeModeVal === 'light') {
                commit('setIsDark', false)
            } else {
                commit('setIsDark', true)
            }
        }
    },
    mutations: {
        setMode(state, val) {
            state.theme.mode = val;
        },
        setIsDark(state, val) {
            state.theme.isDark = val;
            // Update the root class, for styling
            const root = document.documentElement;
            if (state.theme.isDark) { // Dark
                root.classList.add('dark-theme');
                root.classList.remove('light-theme');
            }
            else { // Light
                root.classList.add('light-theme');
                root.classList.remove('dark-theme');
            }
        }
    },
    getters: {
        mode: state => state.theme.mode,
        isDark: state => state.theme.isDark
    }
};